import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import { ModalAnswer, ModalQuestion } from "../../../components/Modal";
import StatusFlag from "../../../components/StatusFlag";
import getSurvey from "../../../util/getSurvey";
import Pagenation from "../../../components/Pagenation";
import Loading from "../../../components/Loading";
import TableResponsive from "../../../components/TableResponsive";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";
import { toast } from "react-toastify";
import Button from "../../../components/Button";

export default function Quiz() {
  const { me, config } = useWrapper();
  const { formatQuery, formatDate } = useFormat();

  const [isWaitingResponse, setisWaitingResponse] = useState(true);

  useEffect(() => {
    applyFilter(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally runs once on mount with the initial filter; applyFilter/filter are recreated every render and re-including them would refire this on every filter change.
  }, []);

  const [survey, setsurvey] = useState();
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);

  const applyFilter = async (__filter, __setPreset) => {
    try {
      setisWaitingResponse(true);
      const _filter = __filter || filter;
      if (!!__filter) {
        setfilter(__filter);
      }
      let _events =
        me?.packages
          ?.reduce((__acc, __package) => __acc.concat(__package?.event?.map(__event => __event.id)), [])
          ?.concat(me?.packageSingle?.map(__single_event => __single_event.event_id)) || [];
      _events = {
        ...(_events?.length > 0
          ? {
              event_id: String([...new Set(_events)]),
            }
          : {}),
      };
      const _query = `?${formatQuery({
        ..._filter,
        ..._events,
        commercial_id: me.commercial_id,
      })}`;
      const _survey = await getSurvey({
        query: _query,
        config,
        trainee_id: me.id,
      });
      setsurvey(_survey);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar as enquetes.");
    } finally {
      setisWaitingResponse(false);
    }
  };

  const [reload, setreload] = useState();

  const [page] = useState({
    total: null,
    current: null,
  });
  useEffect(() => {
    if (page.current) {
      setreload(!reload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `page.current` is never mutated (no setter is called), so this intentionally only reacts to `page.current`; adding `reload` would create a self-triggering loop since this effect toggles `reload` itself.
  }, [page.current]);

  const [modal, setmodal] = useState();

  return (
    <>
      <Main className={style.mainUser}>
        <Content noBG="true">
          <Row>
            <Col md={12} lg={2}>
              <MenuTrainee />
            </Col>
            <Col>
              <SubContent>
                <div className="d-flex justify-content-between mb-4">
                  {!!me.is_member ? (
                    <>
                      <h2 className="form-title">Enquetes</h2>
                      <Button
                        color="primary"
                        onClick={() => {
                          setmodal({
                            type: "new_survey",
                          });
                        }}
                      >
                        Nova Enquete
                      </Button>
                    </>
                  ) : (
                    <h2 className="form-title">Enquetes</h2>
                  )}
                </div>
                {!isWaitingResponse ? (
                  <>
                    <TableResponsive
                      table={{
                        head: [
                          { data: "ID" },
                          { data: "Pergunta" },
                          { data: "Principal Resposta" },
                          { data: "Respostas" },
                          { data: "Autoria" },
                          { data: "Encerramento" },
                          { data: "Status" },
                        ],

                        body: survey?.data?.map(__question => {
                          return {
                            onClick: () => {
                              setmodal({
                                type: "view_survey",
                                survey_id: __question.id,
                              });
                            },
                            data: [
                              {
                                element: <span>{__question.id}</span>,
                              },
                              {
                                element: <span>{__question.description}</span>,
                              },
                              {
                                element: (
                                  <>
                                    <span>
                                      {!!__question?.surveyOptions?.[0] && (
                                        <>
                                          <span>{__question?.surveyOptions?.[0]?.quest || "-"}</span>
                                          <span className="op-5">
                                            {" "}
                                            ({parseFloat(__question.surveyOptions[0].votes_percent.toFixed(2))}%)
                                          </span>
                                        </>
                                      )}
                                    </span>
                                  </>
                                ),
                              },
                              {
                                element: <span>{__question.surveyAnswer.length}</span>,
                              },
                              {
                                element: (
                                  <span>
                                    {__question?.users?.username || __question?.trainees?.name || "?"}
                                    <span className="op-5">{!!__question.users ? " (Gestor)" : " (Comissão)"}</span>
                                  </span>
                                ),
                              },
                              { element: formatDate(__question?.expires_date, 2) },
                              {
                                element: <StatusFlag status={__question.status} />,
                              },
                            ],
                          };
                        }),
                      }}
                    />
                    <Pagenation
                      current={survey?.page}
                      total={survey?.lastPage}
                      pageChange={__page => {
                        applyFilter({
                          ...filter,
                          page: __page,
                        });
                      }}
                      className="mt-4"
                    />
                  </>
                ) : (
                  <Loading />
                )}
              </SubContent>
            </Col>
          </Row>
        </Content>
      </Main>
      <ModalQuestion
        show={modal?.type === "new_survey"}
        onHide={() => {
          setmodal();
        }}
        refreshCallback={() => {
          applyFilter();
        }}
        commercial_id={me?.commercial_id}
      />{" "}
      <ModalAnswer
        show={modal?.type === "view_survey"}
        onHide={() => {
          setmodal();
        }}
        survey_id={modal?.survey_id}
        refreshCallback={() => {
          applyFilter();
        }}
      />
    </>
  );
}
